/**
 * 카카오 로그인 훅 (프로모션용)
 * - 카카오 OAuth를 통해 idToken을 받아 로그인 처리
 */
export default function useKakaoLoginPromotion() {
  const handleKakaoLoginWeb = () => {
    if (!window.Kakao) {
      console.error("[Kakao Login] SDK가 로드되지 않았습니다.");
      return;
    }

    if (!window.Kakao.isInitialized()) {
      console.error("[Kakao Login] SDK가 초기화되지 않았습니다.");
      return;
    }

    // 콜백(공유 라우트 /promotion/oauth/kakao)이 로그인 취소 시 어느 화면으로
    // 돌려보낼지 알 수 있도록, 클릭 시점의 출처를 OAuth state 로 실어 보낸다.
    // Kakao 는 성공/취소(error) 모두 state 를 그대로 echo 한다.
    const from = window.location.pathname.startsWith("/affiliate")
      ? "affiliate"
      : "promotion";

    window.Kakao.Auth.authorize({
      redirectUri: `${window.location.origin}/promotion/oauth/kakao`,
      scope: "account_email,openid,phone_number,plusfriends",
      state: from,
    });
  };

  return handleKakaoLoginWeb;
}
